import store from './../../../../app/store/store.module';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'textMask'
})
export class TextMaskPipe implements PipeTransform {
  isAllowed(email) {
    if (email) {
      if (email.indexOf('reflaunt.com') > -1) {
        return true;
      }
    }
    return false;
  }

  transform(text: string): string {
    const auth = store.getState().Auth;
    if (!text) {
      return '';
    }
    if (auth && auth.login && auth.login.profile && this.isAllowed(auth.login.profile.email)) {
      return text;
    } else {
      return text.split(/[.,@]/).map(part => {
        const separatorIndex = text.indexOf(part) + part.length;
        const separator = text[separatorIndex];
        let content;
        if (part.length > 4) {
          const len = part.length;
          content = part[0] + (new Array(part.length - 2).fill('*').join('')) + part[len - 1];
        } else {
          content = new Array(part.length).fill('*').join('');
        }
        return content + (separator || '');
      }).join('');
    }
  }
}
